export const gift = () => (
  <path
    d="M20 12v10H4V12m8 10V7m0 0H7.5a2.5 2.5 0 110-5C11 2 12 7 12 7zm0 0h4.5a2.5 2.5 0 000-5C13 2 12 7 12 7zM2 7h20v5H2V7z"
    strokeLinecap="round"
    strokeLinejoin="round"
  />
);
